import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import Fa from 'react-fontawesome';
import { trim, startsWith } from 'lodash';
// Import Actions
import { resetPassword } from '../../../Auth/AuthActions';

// Import Selectors
import { getUser } from '../../../Auth/AuthReducer';

class RequestChangePassword extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  close() {
    if (this.mounted) {
      this.setState({ showModal: false });
    }
  }

  open() {
    this.setState({ showModal: true });
  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (!valid) {
      return;
    }
    this.props.dispatch(resetPassword(data.password))
      .then(
        () => {
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, type, placeholder, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <FormControl {...input} autoComplete="off" placeholder={placeholder} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const {
      handleSubmit, submitting, valid, user, location: { pathname },
    } = this.props;
    let show = false;
   
    if (user._id && !startsWith(pathname, '/signin') && pathname !== '/logout') {
      if (user.is_none_standard_user && user.password_last_reset === null) {
        show = true;
      }
    }
    if (!show) {
      return null;
    }

    return (
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>Reset Password</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <p>Please update your password because this is the first time you have signed in or your password has expired.</p>
            <Field
              disabled={submitting}
              name="password"
              type="password"
              component={this.renderField}
              label="Password"
              placeholder="Create new password"
            />
            <Field
              disabled={submitting}
              name="password_confirmation"
              type="password"
              component={this.renderField}
              label="Confirm new password"
              placeholder="enter your new password again"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" type="submit" disabled={submitting || !valid}>
              <Fa name="edit" /> Submit
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

RequestChangePassword.propTypes = {
  submitting: PropTypes.bool,
  valid: PropTypes.bool,
  handleSubmit: PropTypes.func,
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};
RequestChangePassword.defaultProps = {
};

const validate = (values) => {
  const errors = {};

  if (!values.password_confirmation) {
    errors.password_confirmation = 'Please enter your password again';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (trim(values.password).length < 8) {
    errors.password = 'Please enter at least 8 characters';
  } else if (values.password_confirmation && values.password_confirmation !== values.password) {
    errors.password_confirmation = 'Password confirmation does not match';
  }

  return errors;
};
const RequestChangePasswordForm = reduxForm({
  form: 'requestChangePasswordForm',
  validate,
})(RequestChangePassword);

export default connect(mapStateToProps)(RequestChangePasswordForm);
